import { render, staticRenderFns } from "./ParkingPenalties.vue?vue&type=template&id=8ef6e0ee"
import script from "./ParkingPenalties.vue?vue&type=script&lang=js"
export * from "./ParkingPenalties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports